/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_Field_SubtitleInputs */

const vi_grower_area_qr_field_subtitle = /** @type {(inputs: Grower_Area_Qr_Field_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In và cắm ở thửa: quét bằng điện thoại để mở trang thông tin vùng trồng`)
};

/**

* @param {Grower_Area_Qr_Field_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_field_subtitle = /** @type {((inputs?: Grower_Area_Qr_Field_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_Field_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_field_subtitle(inputs)
});